<div [class]="prefixCls">
  <button [class]="prefixCls + '-super-prev-btn'" [style.visibility]="showSuperPreBtn ? 'visible' : 'hidden'" [a11yTitle]="'previous_year' | localize" (click)="superPrevious()" tabindex="0" ui-button>
    <i ui-icon uiType="two-arrows-left-small"></i>
  </button>
  <button [class]="prefixCls + '-prev-btn'" [style.visibility]="showPreBtn ? 'visible' : 'hidden'" [a11yTitle]="'previous_month' | localize" (click)="previous()" tabindex="0" ui-button>
    <i ui-icon uiType="chevron-left-small"></i>
  </button>

  <div [class]="prefixCls + '-view'" [id]="uiLabelId" aria-live="polite">
    <ng-container *ngFor="let selector of selectors">
      <button [class]="selector.className" [attr.aria-label]="selector.ariaLabel" (click)="selector.onClick()" ui-button uiType="link">
        {{ selector.label }}
      </button>
    </ng-container>
  </div>
  <button [class]="prefixCls + '-next-btn'" [style.visibility]="showNextBtn ? 'visible' : 'hidden'" [a11yTitle]="'next_month' | localize" (click)="next()" tabindex="0" ui-button>
    <i ui-icon uiType="chevron-right-small"></i>
  </button>
  <button [class]="prefixCls + '-super-next-btn'" [style.visibility]="showSuperNextBtn ? 'visible' : 'hidden'" [a11yTitle]="'next_year' | localize" (click)="superNext()" ui-button tabindex="0">
    <i ui-icon uiType="two-arrows-right-small"></i>
  </button>
</div>
